<template>
    <div class="plan-select">
        <h2 class="plan-select--heading">{{$t('REGISTER_SELECT_PLAN_HEADING')}}</h2>
        <p class="plan-select--text">{{$t('REGISTER_SELECT_ARRANGEMENTS')}}</p>
        <img src="@/assets/images/decoration/checkout-flowers.jpeg" height="301" width="100%" alt="Selected indicator icon">
        <div class="whats-in-box-container">
            <p class="whats-in-box-container--title">{{$t('REGISTER_WHATS_IN_THE_BOX')}}</p>
            <div class="box-direction" v-for="(option, index) in whatsInTheBoxOptions" :key="index">
                <img src="@/assets/images/decoration/tick-green.svg" alt="Selected indicator icon">
                <p class="whats-in-box-container--text">{{option}}</p>
            </div>
        </div>
        <h2 class="plan-select--heading">{{$t('REGISTER_HOW_OFTEN')}}</h2>
        <p class="plan-select--text">{{$t('REGISTER_PAUSE_CHANGE')}}</p>
        <!-- <custom-select trackBy="plan_interval" v-model="currentSelectedPlan" :options="options" :defaultOption="selectedPlan"/> -->
        <multiselect
            v-model="currentSelectedPlan"
            track-by="plan_interval"
            label="plan_name"
            placeholder="Please select plan"
            openDirection="below"
            :mandatory="true"
            :allow-empty="false"
            :options="options"/>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import CustomSelect from '@/components/partials/register/CustomSelect';

const i18n = require('@/i18n').default;

export default {
    name: 'SelectPlan',
    components: {
        // CustomSelect,
        Multiselect,
    },
    data() {
        return {
            currentSelectedPlan: null,
            whatsInTheBoxOptions: [
                i18n.t('REGISTER_WHATS_IN_THE_BOX_1'),
                i18n.t('REGISTER_WHATS_IN_THE_BOX_2'),
                i18n.t('REGISTER_WHATS_IN_THE_BOX_3'),
            ],
        };
    },
    computed: {
        options() {
            return this.$store.getters['register/getAllPlans'];
        },
        selectedPlan() {
            return this.$store.getters['register/getSelectedPlan'] || this.options[1];
        },
    },
    mounted() {
        this.currentSelectedPlan = !this.selectedPlan ? this.options[0] : this.selectedPlan;
    },
    watch: {
        currentSelectedPlan(value) {
            this.$store.commit('register/setSelectedPlan', value);
        },
    },
};
</script>
<style>
.multiselect__tags {
    border-color: #CECECE !important;
}
</style>

<style lang="scss" scoped>
.plan-select {
    max-width: 550px;
    margin: 0px auto;
    &--text {
        font-size: 16px;
        line-height: 140%;
        margin: 20px auto;
    }
    &--heading {
        font-size: 25px;
        line-height: 130%;
    }
}

.whats-in-box-container {
    background-color: #F7F7F7;
    padding: 15px 30px;
    margin: 20px 0px;
    &--title {
        font-weight: 400;
        font-size: 16px;
        line-height: 150%;
    }
    &--text {
        font-size: 16px;
        line-height: 140%;
        margin: 5px 15px;
    }
}

.box-direction {
    display: flex;
    flex-direction: row;
    align-items: center;
    & img {
        width: 9px;
        height: 6px;
    }
}
</style>
